module.exports = __webpack_public_path__ + "static/media/conversionSuccesful.85708e76.svg";